import React, { Component } from "react";
import PropTypes from "prop-types";
import RSAlert from "reactstrap/lib/Alert";

import { gatherClasses, isFunction } from "../../lib/utils";
import "./alert.scss";

/**
 * Alert component can be used to notify user about some state
 * It could be success, warning or error
 * Optionally an alert component can be closable
 * Ideally, critical alerts should not be closable so that they can grab user's attention.
 */
class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }

  onCloseClick = () => {
    const { closable, onClose } = this.props;
    this.setState(
      {
        isOpen: false
      },
      () => {
        if (closable && isFunction(onClose)) {
          onClose();
        }
      }
    );
  };

  render() {
    const { dataTestId, type, closable, message } = this.props;
    const { isOpen } = this.state;
    return (
      <RSAlert
        data-testid={dataTestId}
        className={gatherClasses(this.props)}
        color={type}
        isOpen={isOpen}
        toggle={closable ? this.onCloseClick : null}
      >
        {message}
      </RSAlert>
    );
  }
}

Alert.propTypes = {
  /**
   * message: the text to be shown under the Alert
   * message is the mandatory property
   */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  /**
   * type: type of the Alert. Any one from the given list
   * default type is success
   */
  type: PropTypes.oneOf(["success", "warning", "danger", "info"]),
  /**
   * closable: a flag to specify if an alert is closable or not
   * by default it is false
   */
  closable: PropTypes.bool,
  /**
   * onClose: a callback function to notify that the alert is being closed
   * applicable only if alert is closable
   */
  onClose: PropTypes.func,
  dataTestId: PropTypes.string
};

Alert.defaultProps = {
  type: "danger",
  closable: false,
  dataTestId: "orion-alert"
};

Alert.displayName = "OrionAlert";

export default Alert;
